import { Flex, Text } from "@chakra-ui/react";
import { FaChevronRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

export type BreadCrumbItems = {
  breadCrumbText: string;
  breadCrumbPath: string;
};

interface BreadProps {
  breadCrumbItems?: BreadCrumbItems[];
  breadCrumbActiveItem: string;
}

export function BreadCrumbs({
  breadCrumbItems,
  breadCrumbActiveItem,
}: BreadProps) {
  const navigate = useNavigate();
  return (
    <Flex
      display={{ base: "flex", md: "flex" }}
      mb="3"
      justifyContent={"center"}
      gap="2"
      alignItems="center"
      width={"100vw"}
      bg="white"
      height={"70px"}
      border={"1px solid #D5D5D5"}
      px="1rem"
    >
      {breadCrumbItems?.map((item, index) => (
        <Flex
          alignItems="center"
          justifyContent={"center"}
          gap="2"
          cursor="pointer"
          onClick={() => {
            navigate(item.breadCrumbPath);
          }}
          key={index}
        >
          <Text
            color={
              item.breadCrumbText === breadCrumbActiveItem ? "red" : "midGrey"
            }
            fontWeight="semibold"
            fontSize={["14px", "14px", "14px"]}
            textAlign={"center"}
          >
            {item.breadCrumbText}
          </Text>
          {index !== breadCrumbItems.length - 1 && (
            <FaChevronRight fontSize="md" color="#EDD0D0" />
          )}
        </Flex>
      ))}
      {/* <FaChevronRight fontSize="sm" />
      <Text color="black" fontWeight="semibold">{breadCrumbActiveItem}</Text> */}
    </Flex>
  );
}
